import React from 'react';
import makeAnimated from 'react-select/animated';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { components as SelectComponent, default as ReactSelect } from 'react-select';
import { emToPx } from '../../repiUtils';
import { Circles } from '../../../common/loadingComponent';
import { SECTIONS, reportActions } from '../../../../store/reportStore';
import { domainActions } from '../../../../store/domainStore';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { repiActions, repiDomain, repiLimits } from '../../../../store/repiStore';
import Paging from '../../../common/pagingComponent';
import BbCheckbox from '../../../styling/bbCheckbox';
import RepiContract from './repiContract';

import '../../repi.scss';

const animatedComponent = makeAnimated();

class RepiContractsHistory extends React.Component {
    state = {
        filterStateSelected: null,
        filterContractTypeSelected: null,
        page: 1,
        contracts: []
    };

    render() {
        if (isNullOrUndefined(this.props.data))
            return null;

        return (
            <>
                <div className="repi-payment-history-contract-history-header repi-payment-history-1em-wrapper">
                    <div className="repi-subsection-header">
                        <Translate id="Repi.Report.PaymentHistory.ContractsAndClaimEnforcements" />
                    </div>
                    <div style={{ fontSize: "0.8em", alignSelf: "center" }}>
                        <span className="link-functional" onClick={() => this.props.requestFetchSection([SECTIONS.repiReportPaymentHistory])}>
                            <Translate id="Report.Aml.ReloadSection" />
                        </span>
                    </div>
                </div>
                <div className="repi-payment-history-filters repi-payment-history-1em-wrapper columns">
                    <ReactSelect isMulti
                        className="column is-one-quarter filter-react-select"
                        closeMenuOnSelect={false}
                        components={{ animatedComponent, Option }}
                        styles={ReactSelectStyles}
                        isSearchable={false}
                        options={this.getOptionsState()}
                        hideSelectedOptions={false}
                        allowSelectAll={true}
                        onChange={this.handleFilterStateChanged}
                        value={this.state.filterStateSelected}
                        placeholder={<div><Translate id="Repi.Report.PaymentHistory.State" /></div>}
                        getOptionLabel={(o) => this.props.translate(o.label)}
                    />
                    <ReactSelect isMulti
                        className="column is-three-quarters filter-react-select"
                        closeMenuOnSelect={false}
                        components={{ animatedComponent, Option }}
                        styles={ReactSelectStyles}
                        isSearchable={false}
                        options={this.getOptionsContractType()} 
                        hideSelectedOptions={false}
                        allowSelectAll={true}
                        onChange={this.handleFilterContractTypeChanged}
                        value={this.state.filterContractTypeSelected}
                        placeholder={<div><Translate id="Repi.Report.PaymentHistory.ContractType" /></div>}
                        getOptionLabel={(o) => this.props.translate(o.label)}
                    />
                </div>
                <div ref={(el) => this.setContainerRef(el)} id="repi-contracts" className="repi-payment-history-contracts-wrapper">
                    {Object.keys(this.props.domain).find(f => this.props.domain[f].isRequesting)
                        ? <Circles />
                        : this.paginateContracts(this.state.contracts).map((contract) => <RepiContract
                            key={contract.contractId}
                            contract={contract}
                            contractIndex={contract.index}
                            subjectId={this.props.data.subjectId}
                            domain={this.props.domain}
                            pendingData={isNullOrUndefined(this.props.data.pendingData) ? undefined : this.props.data.pendingData[contract.contractId]}
                        />)
                    }
                    {this.renderPaging()}
                </div>
            </>
        );
    }

    componentDidMount() {
        this.props.ensureDomainData(repiDomain.dunningLevels);
        this.props.ensureDomainData(repiDomain.currencies);

        if (this.state.filterStateSelected === null || this.state.filterContractTypeSelected === null) {
            const stateFilter = this.getOptionsState();
            const typeFilter = this.getOptionsContractType();

            this.setState({
                filterStateSelected: stateFilter,
                filterContractTypeSelected: typeFilter,
                contracts: this.filterContracts(stateFilter, typeFilter)
            });
        }
    }

    renderPaging = () => {
        if (isNullOrUndefined(this.state.contracts) || this.state.contracts.length <= repiLimits.paymentHistoryContracts)
            return null;

        const totalPages = Math.ceil(this.state.contracts.length / repiLimits.paymentHistoryContracts).toFixed();
        return (
            <div className="repi-contracts-paging-wrapper">
                <hr/>
                <Paging
                    justify="center"
                    style={{ fontSize: "1.2em" }}
                    selectedPage={this.state.page}
                    totalPages={totalPages}
                    setPage={this.setPage}
                />
            </div>
        );
    }

    getOptionsState = () => {
        let filterOptions = [];

        if (!this.props.data || !this.props.data.paymentHistory || !this.props.data.paymentHistory.detail || !this.props.data.paymentHistory.detail.contracts)
            return filterOptions;
        
        let opened = "opened", closed = "closed", other = "other";

        const data = this.props.data.paymentHistory.detail.contracts;
        data.map((contract) => {
            if (contract.isContractOpen === true && !filterOptions.includes(opened))
                filterOptions.push(opened);
            if (contract.isContractOpen === false && !filterOptions.includes(closed))
                filterOptions.push(closed);
            if (contract.isContractOpen === undefined && !filterOptions.includes(other))
                filterOptions.push(other);
        });

        let filtersNames = [];
        if (filterOptions.includes(opened))
            filtersNames.push({
                value: opened, label: "Repi.Report.PaymentHistory.ContractType.Open"
            });

        if (filterOptions.includes(closed))
            filtersNames.push({
                value: closed, label: "Repi.Report.PaymentHistory.ContractType.Closed"
            });

        if (filterOptions.includes(other))
            filtersNames.push({
                value: other, label: "Repi.Report.PaymentHistory.ContractType.Other"
            });

        return filtersNames;
    }

    getOptionsContractType = (contracts) => {
        let filtersCodes = [];

        if (contracts)
            return filtersCodes;

        const data = this.props.data.paymentHistory.detail.contracts;
        data.map((contract) => {
            if (!filtersCodes.includes(contract.productCode))
                filtersCodes.push(contract.productCode);
        });

        let filtersNames = [];
        filtersCodes.map((code) => {
            filtersNames.push({
                value: code,
                label: "Repi.Report.PaymentHistory.Filter.ContractType." + code
            });
        });

        return filtersNames;
    }

    handleFilterStateChanged = (selected) => {
        this.setState({
            page: 1,
            filterStateSelected: selected,
            contracts: this.filterContracts(selected, this.state.filterContractTypeSelected)
        });
    }

    handleFilterContractTypeChanged = (selected) => {
        this.setState({
            page: 1,
            filterContractTypeSelected: selected,
            contracts: this.filterContracts(this.state.filterStateSelected, selected)
        });
    }

    filterContracts = (stateFilter, typeFilter) => {
        const contracts = get(this.props, "data.paymentHistory.detail.contracts");
        if (isNullOrUndefined(contracts))
            return [];

        const filteredByType = isNullOrUndefined(typeFilter) ? contracts
            : contracts.filter(c => typeFilter.map(x => x.value).includes(c.productCode));

        if (isNullOrUndefined(stateFilter))
            return filteredByType.map((x, i) => ({ ...x, index: i }));
        else {
            const filterByStatusValues = stateFilter.map(x => x.value);
            return filteredByType.filter(c => (
                (filterByStatusValues.includes("opened") && c.isContractOpen === true) ||
                (filterByStatusValues.includes("closed") && c.isContractOpen === false) ||
                (filterByStatusValues.includes("other") && c.isContractOpen === undefined)
            )).map((x, i) => ({ ...x, index: i }));
        }
    }

    paginateContracts = (contracts) => {
        const startIndex = (this.state.page - 1) * repiLimits.paymentHistoryContracts;
        return contracts.slice(startIndex, startIndex + repiLimits.paymentHistoryContracts);
    }

    setPage = (page) => {
        this.setState({ page: page });

        // Navbar height is 3.5em, Repi header height is 4.5em
        if (!isNullOrUndefined(this.containerRef))
            window.scrollTo(0, this.containerRef.offsetTop - (emToPx(3.5) + emToPx(4.5)));
    }

    setContainerRef = (el) => {
        if (isNullOrUndefined(el) || this.containerRef === el)
            return;

        this.containerRef = el;
    }
}

const Option = (props) => {
    return (
        <div>
            <SelectComponent.Option {...props}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <BbCheckbox label='' id={`${props.innerProps.id}-checkbox`} value={props.isSelected} onChange={() => {}} />
                    <> </>
                    <label>{props.label}</label>
                </div>
            </SelectComponent.Option>
        </div>
    );
};

const ReactSelectStyles = {
    menu: (styles) => {
        return localStorage.locales_theme === "dark" ? {
            ...styles,
            backgroundColor: "#1F2123",
            border: "1px solid #ACB3B9"
        } : {
            ...styles
        }
    },
    control: (styles) => {
        return {
            ...styles,
            boxShadow: "none",
            outline: "none",
            backgroundColor: localStorage.locales_theme === "dark" ? "#23262F" : "initial",
        };
    },
    option: (styles, { isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: localStorage.locales_theme === "dark"
                ? (isSelected ? "#00C59E" : isFocused ? "#23262F" : null)
                : (isSelected ? "#F1F1F1" : isFocused ? "#797979" : null),
            color: localStorage.locales_theme === "dark" ? (isSelected ? "#FFF" : "#ACB3B9") : "#333333",
            margin: "5px",
            padding: "4px 6px",
            width: "initial",
            ":active": {
                backgroundColor: localStorage.locales_theme === "dark" ? "#4C1A03" : "#0B809E"
            }
        };
    },
    multiValue: (styles) => {
        return localStorage.locales_theme === "dark" ? {
            ...styles,
            backgroundColor: "#ACB3B9",
            color: "#FFF"
        } : { ...styles };
    },
};

export default connect(
    state => ({ ...state.repi.props, domain: {
        [repiDomain.dunningLevels]: state.domain[repiDomain.dunningLevels],
        [repiDomain.currencies]: state.domain[repiDomain.currencies]
    }}),
    dispatch => bindActionCreators({...repiActions, ...reportActions, ...domainActions}, dispatch)
)(withLocalize(withRouter(RepiContractsHistory)));
